import api from '@/api';

const resource = '/auth';

export default {
  async authenticate(login, senha) {
    const { data } = await api.post(`${resource}/login`, { login, senha });
    return data;
  },
  async listprofiles() {
    const { data } = await api.get(`${resource}/usuario-perfis`);
    return data;
  },
  getListSchools(data) {
    return api.get(`${resource}/usuario-escolas-ei`, {
      params: data,
    });
  },
  getListaTelas() {
    return api.get(`${resource}/listar-telas`);
  },
  getVerificarPermissao(data) {
    return api.get(`${resource}/verificar-permissao-tela`, {
      params: {
        tagTela: data,
      },
    });
  },
  getCheckConnection() {
    return api.get(`${resource}/verificarconexao`);
  },
  async redefinirSenha(email) {
    return api.post(`${resource}/redefinirsenha`, { email });
  },
  async novaSenha(token, senha) {
    return api.post(`${resource}/novasenha`, { token, senha });
  },
  async cadastrar(dados) {
    return api.post(`${resource}/cadastrar`, dados);
  },
  getAvatar(){
    return api.get(`${resource}/avatar`);
  },
  async setAvatar(img) {
    const { data } = await api.post(`${resource}/avatar`, { img });
    return data;
  },
};
